<template>
  <div class="legal-license" :class="classes">
    <div>
      <h4 v-if="head">
        <div v-if="$i18n.locale == 'ru'">
          Политика
          <span class="break-word">конфиден<wbr />циаль<wbr />ности</span>
          портала
          <span class="break-word" v-if="isBox"
            >entertainment.<wbr />aeroflot.<wbr />ru</span
          >
		  <span class="break-word" v-else
            >kinogid.<wbr />aerogroup.<wbr />ru</span
          >
        </div>
        <div v-else-if="$i18n.locale !== 'ru'">
          <span>{{ isBox? $t("legal-policy.title_entertainment"):$t("legal-policy.title_kinogid") }}</span>
        </div>
      </h4>
      <p>
        {{ $t("legal-policy.t1") }}
      </p>
      <p>
        {{ $t("legal-policy.t2") }}
      </p>
      <p>
        {{  isBox? $t("legal-policy.t3_entertainment") :$t("legal-policy.t3_kinogid")}}
      </p>
      <ul>
        <li>
          <p>
            {{ $t("legal-policy.q1") }}
          </p>
          <ul>
            <li>
              {{ $t("legal-policy.q1a1") }}
            </li>
            <li>
              {{ $t("legal-policy.q1a2") }}
            </li>
            <li>
              {{ $t("legal-policy.q1a3") }}
            </li>
            <li>
              {{ $t("legal-policy.q1a4") }}
            </li>
            <li>
              {{ $t("legal-policy.q1a5") }}
            </li>
          </ul>
          <p>
            {{ $t("legal-policy.t4") }}
          </p>
        </li>
        <li>
          <p>
            {{ $t("legal-policy.q2") }}
          </p>
          <p>
            {{ $t("legal-policy.q2a1") }}
          </p>
          <ul>
            <li>
              {{ $t("legal-policy.q2a2") }}
            </li>
            <li>
              {{ $t("legal-policy.q2a3") }}
            </li>
            <li>
              {{ $t("legal-policy.q2a4") }}
            </li>
            <li>
              {{  isBox? $t("legal-policy.q2a5_entertainment"):$t("legal-policy.q2a5_kinogid") }}
            </li>
            <li>
              {{ $t("legal-policy.q2a6") }}
            </li>
          </ul>
        </li>
        <li>
          <p>
            {{ $t("legal-policy.cookie") }}
          </p>
          <p>
            {{ $t("legal-policy.cookie-text") }}
          </p>
        </li>
        <li>
          <p>
            {{ $t("legal-policy.contacts") }}
          </p>
          <p>
            {{ $t("legal-policy.contacts-text") }}
            <a href="https://entertainment.aeroflot.ru/" v-if="isBox">
              https://entertainment.aeroflot.ru/
            </a>
			<a href="https://kinogid.aerogroup.ru/" v-else>
              https://kinogid.aerogroup.ru/
            </a>
			{{ $t("legal-policy.contacts-text-1") }}
          </p>
        </li>
      </ul>
    </div>
    <!-- <div v-else-if="$i18n.locale !== 'ru'">
      <h4 v-if="head">
        Confidentiality Policy for entertainment.aeroflot.ru portal
      </h4>
      <p>
        This Confidentiality Policy contains data on the way the data collected
        by our sites are used, as well as whom you may contact in case of any
        questions or doubts.
      </p>
      <p>
        If you have obtained access to this application via a third-party site,
        such party may also collect data on you. In this case you shall read and
        understand the terms of use and the confidentiality policy of the
        software and the site of this party before installation and use of the
        application to know how the collected data will be used.
      </p>
      <p>
        By using the entertainment.aeroflot.ru portal, the User expresses
        his/her full and unconditional consent to all the terms of the License
        agreement, as well as to Confidentiality Policy of the
        entertainment.aeroflot.ru Portal.
      </p>
      <ul>
        <li>
          <p>
            What kind of data do we collect?
          </p>
          <ul>
            <li>
              Type of the device
            </li>
            <li>
              Type and version of the operating system and (or) software shell
            </li>
            <li>
              Statistics of use of individual files by the User, access to which
              the User obtains by means of the Portal
            </li>
            <li>
              Statistics of use of the Portal functions
            </li>
            <li>
              Other technical information.
            </li>
          </ul>
          <p>
            On our Portal, we may also conduct additional interviews where you
            will be asked to express your opinion on various products and
            services. If you download any materials from our sites, we will
            automatically collect data on your device. We may also save data on
            your actions and personal preferences when you visit our sites (see
            the "Cookies" section below).
          </p>
        </li>
        <li>
          <p>
            What do we do with the collected data?
          </p>
          <p>
            We use collected data for the following purposes:
          </p>
          <ul>
            <li>
              to support the operation of our Portal, as well as to provide you
              with information and services, including, but not limited to,
              downloaded materials, promotional events, and competitions.
            </li>
            <li>
              to provide tech support to you.
            </li>
            <li>
              for the purpose of internal analysis and research to improve our
              products, and services.
            </li>
            <li>
              to provide you with news and marketing information on products and
              services of the entertainment.aeroflot.ru solution, as well as
              proposals, products, and services of selected third-party
              companies, but only to the extent permitted by applicable laws and
              if we obtain appropriate separate consent from you to do so;
            </li>
            <li>
              to detect and prevent any fraud.
            </li>
          </ul>
        </li>
        <li>
          <p>Cookies</p>
          <p>
            Entertainment.aeroflot.ru Portal uses cookie files. These are small
            text files, which are sent by the site to your computer to record
            your actions on the net. Such files may be used by our Portal to
            save your preferences when using our Portal to improve some aspects
            of our operation, to record your actions on the net, as well as to
            provide you with individualized ads and other materials. You may
            disable the use of cookies in the browser parameters menu, but in
            this case some functions of our Portal may become inaccessible.
          </p>
        </li>
        <li>
          <p>Contact information</p>
          <p>
            For general questions contact the help desk using the details
            published on the site:
            <a href="http://entertainment.aeroflot.ru"
              >http://entertainment.aeroflot.ru</a
            >
          </p>
        </li>
      </ul>
    </div> -->
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    head: {
      type: Boolean,
      default: true,
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classes() {
      return {
        "legal-license--small": this.small,
      };
    },
	...mapState("settings", {
      isBox: (state) => state.isBox,
    }),
  },
};
</script>

<style lang="sass" scoped>
.legal-license
  p
    margin-bottom: 12px

  ul
    margin-bottom: 12px

  &--small
    font-size: 16px
    line-height: 22px
</style>
